<template>
  <div class="border dinline-block vtop cpointer fs14 br2 tleft" @click="goDetail(item.id)">
    <div class="prelative">
      <div class="pabsolute tro"></div>
      <div class="ml20 sbg bgw">&nbsp;</div>
    </div>
    <div class="ptxt bgw prelative">
      <div class="dt pabsolute tc12 tcenter">
        <div class="fs22 mb5 tc15">{{day}}</div>
      </div>
      <div class="txt fs16 lh16">
        {{item.title}}
      </div>
    </div>
    <div class="prelative">
      <div class="mr20 sbg bgw"></div>
      <div class="pabsolute bro"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notice-item",
  props: [
    'index',
    'item',
  ],
  data(){
    return {
      day:'01-01',
    }
  },
  methods:{
    goDetail (id){
      let path = `/notice/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      // this.$router.push({path:'/notice/detail',query:{id:id}})
    }
  },
  mounted() {
    var date = new Date(this.item.release_time);
    var dateTime = date.getTime() / 1000;
    this.day = this.$request.date('m-d',dateTime);
  }
}
</script>

<style scoped>
  .index-wrap .ntdiv .border:hover .txt{color: #e4bd31;}
  .index-wrap .ntdiv .border{margin: 0 8px 30px;width: 410px;height: 85px;}
  .index-wrap .ntdiv .sbg{height: 20px;}
  .index-wrap .ntdiv .tro,.index-wrap .ntdiv .bro{border: 10px solid transparent;}
  .index-wrap .ntdiv .tro{border-right-color: #fff; border-bottom-color: #fff;}
  .index-wrap .ntdiv .bro{top: 0;right: 0;border-top-color: #fff; border-left-color: #fff;}
  .index-wrap .ntdiv .txt{padding: 0 5px 0 100px; height: 50px;}
  .index-wrap .ntdiv .dt{top: 0;left: 10px;}
  .index-wrap .ntdiv .dt::after{content: '';position: absolute;top: 0;right: -15px;height: 30px;width: 1px;background: #ddd;}
</style>



// WEBPACK FOOTER //
// src/components/index/notice-item.vue